import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-move-lead-space',
  imports: [SharedModule],
  templateUrl: './move-lead-space.component.html',
  styleUrl: './move-lead-space.component.scss'
})
export class MoveLeadSpaceComponent {

  @Output() closeDialog = new EventEmitter<void>();
  @Input() tabs: any[] = [];
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<void>();
  leadSpaceList: any[] = [];
  constructor(
    private api: LeadService,
    private messageService: MessageService
  ) { }
  selectedLeadSpace: any = {};
  isLoading: boolean = false;

  old_data: any ;

  ngOnChanges() {
    this.leadSpaceList = this.tabs.slice(1);
    this.old_data = this.editLeadData;
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleMoveLead() {

    this.editLeadData = {
      ...this.editLeadData,
      lead_space_id: this.selectedLeadSpace,
    }

    this.editLeadData.old_lead_data = this.old_data;


    this.isLoading = true;

    this.api.updateLead(this.editLeadData).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.selectedLeadSpace = {};
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Lead moved successfully'
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message || 'Something went wrong'
        });
      }
    });

    
  }
}
